export default __webpack_public_path__ + "static/media/linkedin.30834a26.svg";